import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { apiError } from '../../../helpers/ErrorHelper';
import { useAuth } from '../../../context/AuthContext';
import { removeInvoiceItem, saveInvoicesToStorage } from '../../../models/InvoiceModel';
import { useNotificationCount } from '../../../context/NotificationCountContext';
import { removePayment } from '../../../models/PaymentModel';


const DeletePaymentModal = ({showModal, setShowModal,  modalKey, invoice_unique_id, invoiceData, setInvoiceData, paymentData, setPayments}) => {

  const { notificationCount, setNotificationCount } = useNotificationCount();

  const navigate = useNavigate();

    const { state } = useAuth(); 

    let user_data = state.user_data;
    
    const loader = document.getElementById('loading');

    const [loading, setLoading] = useState(false);
    
    const [_payment_id, setPaymentId] = useState('');

    const closeModal = () =>{
        setPaymentId('');
        
        setShowModal(false);
    }

    useEffect(() => {
        //console.log(itemData);
        // This effect will be called whenever noteData changes
        if (invoiceData && paymentData) {
            setPaymentId(paymentData._payment_id);
        }
      }, [invoiceData, paymentData, modalKey]);


    const deletePayment = async() => {
        // Start the loading state
        loader.style.display = 'block';
    
        try {
          const response = await removePayment(user_data.user_token, _payment_id);
    
          if (response.status) {
            toast.success(response.message);
    
            closeModal();
    
            if (response.data.payments) {
                setPayments(response.data.payments);
            }

            if (response.data.invoices && response.data.pagination_invoices) {
              saveInvoicesToStorage(response.data.invoices, response.data.pagination_invoices);
            }

            if (response.data.invoice_data) {
              setInvoiceData(response.data.invoice_data);
            }

            setNotificationCount(localStorage.getItem('unread_notification_count'));
          }
          else{
            toast.error(response.message);
          }  
    
        } catch (error) {
          apiError(error);

          if (error.response.data.invalid_token==1) {
            navigate('/re-login');
          }
        }
    
        // Stop the loading state
        loader.style.display = 'none';
    }

    return (
        <Modal show={showModal} onHide={closeModal}>
            <Modal.Header closeButton>
                <Modal.Title>Delete Payment</Modal.Title>
            </Modal.Header>
    
            <Modal.Body>
                <p>Do you want to delete this payment ? This process can't be undone</p>
            </Modal.Body>
    
            <Modal.Footer>
                <button type="button" className="btn btn-light" onClick={closeModal}>Cancel</button>
                <button type="button" className="btn btn-danger" onClick={deletePayment}>Delete</button>
            </Modal.Footer>
        </Modal>
    );  

}; 


export default DeletePaymentModal;